module.exports = __webpack_public_path__ + "img/determined_ios_802.png";